import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e683da46"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "welfare"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "welfare-info"
}, [/*#__PURE__*/_createElementVNode("p", null, " 2018年，全民幸福社创始人李文超先生和徐秋秋女士，本着“只有感受过被爱的人，才更会去爱别人”的初心，创办了秋文公益基金会。自公益基金会成立以来，全民幸福社以用心理学幸福世界为己任，主动承担社会责任，开展雏鹰助学等一系列公益活动，通过助力困境儿童求学、赋能在职教师心理，拓宽从业者技能及就业路径等等方式，提升幸福心理学在全社会的影响力，令幸福心理学如“一捧微光”，去照亮世界。 ")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "welfare-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/about-us/originator-1.png"
})], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/about-us/welfare-1.png"
}, null, -1));
const _hoisted_5 = ["href"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "welfare-swiper-item-title"
};
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
// import required modules
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
export default /*#__PURE__*/_defineComponent({
  __name: 'company-welfare',
  setup(__props) {
    const modules = [Pagination];
    const newsList = [{
      image: "https://img2.qiuwenxinli.com/official-website/about-us/welfare-new-1.jpg",
      title: "秋文公益基金会赴重庆慰问英雄蒋正全家属",
      url: "https://new.qq.com/rain/a/20220819A0B05A00.html"
    }, {
      image: "https://img2.qiuwenxinli.com/official-website/about-us/welfare-new-2.jpg",
      title: "大众网专访秋文公益发起人李文超：从“我”到“我们”的公益之路",
      url: "https://www.toutiao.com/article/7161693852871705101/?wid=1694510259785"
    }, {
      image: "https://img02.e23.cn/26b07e8d9385cb406f0f68ec57ac59e1",
      title: "青心相伴 “益”路同行秋文公益助学项目正式启动",
      url: "https://news.e23.cn/jnyc/2022-05-25/2022052500406.html"
    }];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, _createVNode(_unref(Swiper), {
        style: {
          '--swiper-theme-color': '#FFC56E'
        },
        modules: modules,
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        pagination: {
          clickable: true
        },
        class: "welfare-swiper"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(newsList, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              class: "welfare-swiper-item",
              href: item.url
            }, [_createElementVNode("img", {
              class: "welfare-swiper-item-img",
              src: item.image
            }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1)], 8, _hoisted_5)]),
            _: 2
          }, 1024);
        }), 64))]),
        _: 1
      })]);
    };
  }
});